import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Player from '../../components/common/player.component';
import SnackbarInfo from '../../components/common/snackbar-info.component';
import { playbackDataById } from '../../services/videos.service';

const VideoPreviewView = () => {
  const { id } = useParams();
  const [videoData, setVideoData] = useState(null);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });

  useEffect(() => {
    setSnackbarInfo({ ...snackbarInfo, show: false });

    playbackDataById(id)
      .then((res) => {
        setVideoData(res.data)
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
      });
  }, [id]);

  return (
    <>
      <Player videoUrl={videoData?.url} height="100%" width="100%" autoplay subtitles={videoData?.subtitles} />

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </>
  );
};

export default VideoPreviewView;
